export function isUrl(s: string | undefined | null): boolean {
  try {
    const u = new URL(s ?? '');
    return u.protocol === 'https:' || u.protocol === 'http:';
  } catch {
    return false;
  }
}

export function isTeams(s: string | undefined | null): boolean {
  try {
    const u = new URL(s ?? '');
    return u.protocol === 'https:' && /(^|\.)teams\.(microsoft|live)\.com$/.test(u.hostname);
  } catch {
    return false;
  }
}

export function isYouTube(s: string | undefined | null): boolean {
  try {
    const u = new URL(s ?? '');
    return /(^|\.)(youtube\.com|youtu\.be)$/.test(u.hostname);
  } catch {
    return false;
  }
}

/** Placeholder links used in demo data. Shown with a notice instead of navigating. */
export const isDemoLink = (u: string | undefined | null): boolean =>
  /DEMO|example\.com/i.test(u ?? '');
